var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Events",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-1, .cls-2 {\n        opacity: .2;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        mask: url(#mask-2);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-6 {\n        mask: url(#mask-3);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-8 {\n        fill: #ff99d5;\n        opacity: .1;\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-2 {\n        fill: #10f;\n      }\n\n      .cls-11 {\n        mask: url(#mask-1);\n      }\n\n      .cls-12 {\n        mask: url(#mask);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 773.99,
    cy: 198.7,
    fx: 773.99,
    fy: 198.7,
    r: 105.87,
    gradientTransform: "translate(-541.52 -79.06) scale(.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    className: "cls-7",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 121.86,
    cy: 86.8,
    fx: 121.86,
    fy: 86.8,
    r: 53.59,
    gradientTransform: "translate(143.6 -52.41) rotate(80.78) scale(.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 25.67,
    y: 26.96,
    width: 105.56,
    height: 105.56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 78.44,
    cy: 79.74,
    r: 52.78,
    transform: "translate(-12.83 144.39) rotate(-80.78)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 773.99,
    cy: 198.7,
    fx: 773.99,
    fy: 198.7,
    r: 87.3,
    gradientTransform: "translate(-541.52 -79.06) scale(.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-3",
    "data-name": "bg",
    className: "cls-10",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.77,
    y1: 79.74,
    x2: 147.12,
    y2: 79.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#009dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#06f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 773.99,
    cy: 198.7,
    fx: 773.99,
    fy: 198.7,
    r: 105.87,
    gradientTransform: "translate(-541.52 -79.06) scale(.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-5",
    "data-name": "bg",
    className: "cls-5",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 9.77,
    y1: 79.74,
    x2: 147.12,
    y2: 79.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ae00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a501ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8c06ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#640eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2e18ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-2",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.05,97.81c-.1,.27-.2,.54-.3,.8H29.15c-.1-.27-.21-.53-.3-.8h99.2Zm-98.59,1.61c.11,.27,.22,.54,.33,.8H127.1c.11-.27,.22-.53,.33-.8H29.46Zm-1.17-3.21c.09,.27,.18,.54,.27,.8h99.77c.09-.27,.18-.53,.27-.8H28.29Zm-.5-1.61c.08,.27,.16,.54,.24,.8h100.83c.08-.27,.16-.54,.24-.8H27.79Zm2.35,6.43c.12,.27,.24,.54,.36,.8H126.39c.12-.27,.24-.53,.36-.8H30.14Zm-2.79-8.03c.07,.27,.14,.54,.22,.8h101.76c.07-.27,.15-.53,.22-.8H27.34Zm4.34,11.25c.14,.27,.28,.54,.43,.8H124.77c.15-.27,.29-.53,.43-.8H31.69Zm.88,1.61c.15,.27,.31,.54,.47,.8H123.85c.16-.27,.32-.53,.47-.8H32.57Zm-1.69-3.21c.13,.27,.26,.54,.4,.8H125.61c.13-.27,.27-.53,.4-.8H30.88Zm-4.95-17.67c.03,.27,.06,.54,.09,.8h104.87c.03-.27,.06-.53,.09-.8H25.92Zm-.13-1.61c.02,.27,.04,.54,.06,.8h105.19c.02-.27,.04-.53,.06-.8H25.79Zm-.08-1.61c.01,.27,.02,.54,.03,.8h105.41c.01-.27,.02-.54,.03-.8H25.71Zm1.25,9.64c.06,.27,.12,.54,.19,.8h102.59c.06-.27,.13-.53,.19-.8H26.96Zm-.33-1.61c.05,.27,.1,.54,.16,.8h103.32c.06-.27,.11-.54,.16-.8H26.62Zm-.28-1.61c.04,.27,.09,.54,.13,.8h103.94c.05-.27,.09-.54,.13-.8H26.34Zm-.23-1.61c.03,.27,.07,.54,.11,.8h104.45c.04-.27,.08-.53,.11-.8H26.1Zm16.73,32.13c.3,.27,.6,.54,.9,.8H113.15c.3-.26,.6-.53,.9-.8H42.84Zm1.84,1.61c.33,.27,.66,.54,.99,.8H111.22c.33-.26,.66-.53,.99-.8H44.68Zm9.71,6.43c.54,.28,1.09,.54,1.64,.8h44.82c.55-.26,1.1-.53,1.64-.8H54.39Zm-5.44-3.21c.41,.27,.82,.54,1.23,.8h56.52c.41-.26,.82-.53,1.23-.8H48.95Zm-2.25-1.61c.36,.27,.73,.54,1.09,.8h61.29c.37-.26,.73-.53,1.09-.8H46.71Zm4.79,3.21c.46,.27,.93,.54,1.4,.8h51.11c.47-.26,.94-.53,1.4-.8H51.49Zm16.85,6.43c1.93,.37,3.9,.65,5.9,.8h8.39c2-.16,3.97-.43,5.9-.8h-20.2Zm-6.22-1.61c.9,.29,1.8,.56,2.72,.8h27.2c.92-.24,1.82-.51,2.72-.8H62.12Zm-4.3-1.61c.66,.28,1.33,.55,2.01,.8h37.22c.68-.26,1.35-.52,2.01-.8H57.82Zm-16.67-11.25c.27,.27,.55,.54,.82,.8H114.91c.28-.26,.55-.53,.82-.8H41.16Zm-15.48-36.95c0,.27,0,.54,.01,.8h105.53c0-.27,0-.54,.01-.8H25.67Zm8.88,28.92c.18,.27,.36,.54,.55,.8H121.78c.19-.27,.37-.53,.55-.8H34.55Zm2.33,3.21c.21,.27,.43,.54,.64,.8H119.36c.22-.27,.43-.53,.64-.8H36.88Zm-1.21-1.61c.2,.27,.39,.54,.59,.8H120.62c.2-.27,.4-.53,.59-.8H35.67Zm2.52,3.21c.23,.27,.46,.54,.7,.8H118c.23-.27,.47-.53,.7-.8H38.2Zm-4.67-6.43c.17,.27,.33,.54,.5,.8H122.86c.17-.27,.34-.53,.5-.8H33.52Zm6.09,8.03c.25,.27,.5,.54,.75,.8H116.52c.25-.26,.51-.53,.75-.8H39.62ZM64.84,28.73c-.92,.24-1.82,.51-2.72,.8h32.64c-.9-.29-1.8-.56-2.72-.8h-27.2Zm-24.47,14.46c-.25,.26-.51,.53-.75,.8H117.27c-.25-.27-.5-.54-.75-.8H40.37Zm-1.48,1.61c-.23,.27-.47,.53-.7,.8H118.69c-.23-.27-.46-.54-.7-.8H38.89Zm4.85-4.82c-.3,.26-.6,.53-.9,.8H114.05c-.3-.27-.6-.54-.9-.8H43.74Zm-10.7,12.85c-.16,.27-.32,.53-.47,.8H124.32c-.15-.27-.31-.54-.47-.8H33.03Zm8.94-11.25c-.28,.26-.55,.53-.82,.8H115.73c-.27-.27-.55-.54-.82-.8H41.98Zm-7.95,9.64c-.17,.27-.34,.53-.5,.8H123.37c-.17-.27-.33-.54-.5-.8H34.02Zm2.24-3.21c-.2,.27-.4,.53-.59,.8H121.21c-.2-.27-.39-.54-.59-.8H36.27Zm-1.16,1.61c-.19,.27-.37,.53-.55,.8H122.33c-.18-.27-.36-.54-.55-.8H35.1Zm2.42-3.21c-.22,.27-.43,.53-.64,.8H120.01c-.21-.27-.43-.54-.64-.8H37.53Zm18.51-14.46c-.55,.26-1.1,.53-1.64,.8h48.11c-.54-.28-1.09-.54-1.64-.8H56.03Zm3.8-1.61c-.68,.26-1.35,.52-2.01,.8h41.25c-.66-.28-1.33-.55-2.01-.8H59.83Zm14.41-3.21c-2,.16-3.97,.43-5.9,.8h20.2c-1.93-.37-3.9-.65-5.9-.8h-8.39Zm-26.45,9.64c-.37,.26-.73,.53-1.09,.8h63.48c-.36-.27-.73-.54-1.09-.8H47.8Zm-2.13,1.61c-.33,.26-.66,.53-.99,.8H112.21c-.33-.27-.66-.54-.99-.8H45.67Zm4.52-3.21c-.41,.26-.82,.53-1.23,.8h58.98c-.41-.27-.82-.54-1.23-.8H50.18Zm2.71-1.61c-.47,.26-.94,.53-1.4,.8h53.9c-.46-.27-.93-.54-1.4-.8H52.89Zm-23.1,25.7c-.11,.27-.22,.53-.33,.8H127.43c-.11-.27-.22-.54-.33-.8H29.79Zm-3.32,11.25c-.05,.27-.09,.54-.13,.8h104.21c-.04-.27-.09-.54-.13-.8H26.47Zm.67-3.21c-.06,.27-.13,.53-.19,.8h102.97c-.06-.27-.12-.54-.19-.8H27.15Zm-.93,4.82c-.04,.27-.08,.53-.11,.8h104.68c-.03-.27-.07-.54-.11-.8H26.22Zm.57-3.21c-.06,.27-.11,.54-.16,.8h103.64c-.05-.27-.1-.54-.16-.8H26.78Zm-1.04,8.03c-.01,.27-.02,.54-.03,.8h105.47c0-.27-.02-.54-.03-.8H25.74Zm.27-3.21c-.03,.27-.06,.53-.09,.8h105.04c-.03-.27-.06-.54-.09-.8H26.01Zm-.16,1.61c-.02,.27-.04,.54-.06,.8h105.3c-.02-.27-.04-.54-.06-.8H25.85Zm-.17,3.21c0,.27,0,.54-.01,.8h105.55c0-.27,0-.54-.01-.8H25.68Zm6.44-24.1c-.15,.27-.29,.53-.43,.8H125.2c-.14-.27-.28-.54-.43-.8H32.12Zm-1.62,3.21c-.12,.27-.24,.53-.36,.8H126.75c-.12-.27-.24-.54-.36-.8H30.5Zm.77-1.61c-.13,.27-.27,.53-.4,.8H126.01c-.13-.27-.26-.54-.4-.8H31.27Zm-3.25,8.03c-.08,.27-.16,.54-.24,.8h101.31c-.08-.27-.16-.54-.24-.8H28.03Zm-.47,1.61c-.07,.27-.15,.53-.22,.8h102.2c-.07-.27-.14-.54-.22-.8H27.56Zm1-3.21c-.09,.27-.18,.53-.27,.8h100.31c-.09-.27-.18-.54-.27-.8H28.56Zm.59-1.61c-.1,.27-.21,.53-.3,.8h99.2c-.1-.27-.2-.54-.3-.8H29.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-4",
    "data-name": "bg",
    className: "cls-13",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-6",
    "data-name": "bg",
    className: "cls-1",
    x: 9.77,
    y: 11.06,
    width: 137.35,
    height: 137.35
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.44,60.73c-2.46-5.82-5.98-11.04-10.47-15.52-4.48-4.48-9.71-8.01-15.52-10.47-6.02-2.55-12.42-3.84-19.01-3.84s-12.99,1.29-19.01,3.84c-5.82,2.46-11.04,5.98-15.52,10.47-4.48,4.48-8.01,9.71-10.47,15.52-2.55,6.02-3.84,12.42-3.84,19.01s1.29,12.99,3.84,19.01c2.46,5.82,5.98,11.04,10.47,15.52,4.48,4.48,9.71,8.01,15.52,10.47,6.02,2.55,12.42,3.84,19.01,3.84s12.99-1.29,19.01-3.84c5.82-2.46,11.04-5.98,15.52-10.47,4.48-4.48,8.01-9.71,10.47-15.52,2.55-6.02,3.84-12.42,3.84-19.01s-1.29-12.99-3.84-19.01Zm-45,66.32c-26.09,0-47.31-21.22-47.31-47.31s21.22-47.31,47.31-47.31,47.31,21.22,47.31,47.31-21.22,47.31-47.31,47.31Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.81,115.94c.1,.41-.16,.82-.57,.92h-.03s-.1,.02-.15,.02c-.35,0-.66-.24-.74-.59-.1-.41,.16-.82,.56-.92,.41-.1,.82,.16,.92,.57Zm27.95-44.14c-.08-.4-.5-.67-.9-.59-.2,.04-.37,.16-.48,.33-.11,.16-.14,.36-.11,.55v.02c.54,2.52,.81,5.1,.81,7.65,0,15.07-9.46,28.81-23.54,34.17-.19,.07-.34,.22-.42,.4-.08,.19-.09,.4-.02,.58,.11,.29,.4,.49,.71,.49,.1,0,.19-.02,.28-.05,3.64-1.39,7.02-3.32,10.07-5.73,2.98-2.36,5.58-5.15,7.74-8.29,2.16-3.14,3.83-6.56,4.96-10.18,1.16-3.69,1.75-7.52,1.75-11.39,0-2.67-.28-5.35-.84-7.97Zm-32.98-28.45s.06,0,.09,0c.39,0,.71-.29,.76-.67,.05-.42-.25-.8-.67-.85s-.8,.25-.85,.66c-.05,.42,.25,.8,.67,.85Zm-11.95,.55c2.34-.5,4.73-.77,7.1-.8,.2,0,.39-.08,.54-.23,.14-.14,.22-.34,.21-.54,0-.42-.35-.75-.76-.75h-.01c-2.47,.04-4.96,.32-7.39,.84-7.8,1.66-14.76,5.62-20.14,11.47-2.59,2.82-4.73,5.99-6.38,9.45-1.66,3.49-2.78,7.19-3.33,11-.03,.2,.02,.4,.14,.57,.12,.16,.3,.27,.5,.3,.03,0,.07,0,.11,0,.38,0,.7-.28,.76-.66,2.16-15.15,13.68-27.46,28.65-30.65Zm19.82,1.29c.08,.03,.17,.05,.26,.05,.32,0,.61-.21,.72-.51,.14-.4-.07-.84-.46-.98-.39-.14-.84,.08-.98,.47-.07,.19-.06,.4,.03,.58,.09,.18,.24,.32,.44,.39Zm-11.77,71.17h-.01c-.42,0-.76,.35-.76,.77,0,.42,.35,.76,.76,.76h.01c.42,0,.76-.35,.75-.77,0-.41-.35-.75-.76-.75Zm8.72-61.05v-2.29c0-1.26,1.03-2.29,2.29-2.29h1.53c1.26,0,2.29,1.03,2.29,2.29v2.29h.76c.42,0,.76,.34,.76,.76s-.34,.76-.76,.76h-.76v2.29c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29v-2.29h-15.26v2.29c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29v-2.29h-5.34c-.42,0-.76,.34-.76,.76v9.92h.76c.42,0,.76,.34,.76,.76s-.34,.76-.76,.76h-.76v29.76c0,.42,.34,.76,.76,.76h38.15c.42,0,.76-.34,.76-.76v-29.76h-32.81c-.42,0-.76-.34-.76-.76s.34-.76,.76-.76h32.81v-11.45c0-.42,.34-.76,.76-.76s.76,.34,.76,.76v11.45h2.29c.42,0,.76,.34,.76,.76s-.34,.76-.76,.76h-2.29v29.76c0,1.26-1.03,2.29-2.29,2.29H60.89c-1.26,0-2.29-1.03-2.29-2.29v-29.76h-.76c-.42,0-.76-.34-.76-.76s.34-.76,.76-.76h.76v-9.92c0-1.26,1.03-2.29,2.29-2.29h5.34v-2.29c0-1.26,1.03-2.29,2.29-2.29h1.53c1.26,0,2.29,1.03,2.29,2.29v2.29h15.26Zm-16.79,1.53h-.76c-.42,0-.76-.34-.76-.76s.34-.76,.76-.76h.76v-2.29c0-.42-.34-.76-.76-.76h-1.53c-.42,0-.76,.34-.76,.76v6.1c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-2.29Zm18.31,2.29c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-2.29h-.76c-.42,0-.76-.34-.76-.76s.34-.76,.76-.76h.76v-2.29c0-.42-.34-.76-.76-.76h-1.53c-.42,0-.76,.34-.76,.76v6.1Zm-32.81-.76c-.42,0-.76,.34-.76,.76v40.44c0,2.52,2.05,4.58,4.58,4.58h37.39c.42,0,.76-.34,.76-.76s-.34-.76-.76-.76H60.13c-1.68,0-3.05-1.37-3.05-3.05V59.13c0-.42-.34-.76-.76-.76Zm35.86,48.07c0-.42-.34-.76-.76-.76H59.37c-2.95,0-5.34-2.4-5.34-5.34V62.18c0-.42-.34-.76-.76-.76s-.76,.34-.76,.76v38.15c0,3.79,3.08,6.87,6.87,6.87h32.05c.42,0,.76-.34,.76-.76Zm-28.23-38.92c-.42,0-.76,.34-.76,.76s.34,.76,.76,.76,.76-.34,.76-.76-.34-.76-.76-.76Zm32.81,5.34c0-.42-.34-.76-.76-.76s-.76,.34-.76,.76,.34,.76,.76,.76,.76-.34,.76-.76Zm-3.05,33.58c0,.42,.34,.76,.76,.76s.76-.34,.76-.76-.34-.76-.76-.76-.76,.34-.76,.76Zm-12.97-29.76c-.42,0-.76,.34-.76,.76s.34,.76,.76,.76,.76-.34,.76-.76-.34-.76-.76-.76Zm16.79-19.84c.42,0,.76-.34,.76-.76s-.34-.76-.76-.76-.76,.34-.76,.76,.34,.76,.76,.76Zm-30.52,33.58c1.26,0,2.29,1.03,2.29,2.29v1.53c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29v-1.53c0-1.26,1.03-2.29,2.29-2.29h1.53Zm0,1.53h-1.53c-.42,0-.76,.34-.76,.76v1.53c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-1.53c0-.42-.34-.76-.76-.76Zm11.45,.76v1.53c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29v-1.53c0-1.26,1.03-2.29,2.29-2.29h1.53c1.26,0,2.29,1.03,2.29,2.29Zm-1.53,0c0-.42-.34-.76-.76-.76h-1.53c-.42,0-.76,.34-.76,.76v1.53c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-1.53Zm4.58,1.53v-1.53c0-1.26,1.03-2.29,2.29-2.29h1.53c1.26,0,2.29,1.03,2.29,2.29v1.53c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29Zm1.53,0c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-1.53c0-.42-.34-.76-.76-.76h-1.53c-.42,0-.76,.34-.76,.76v1.53Zm11.45-3.82c1.26,0,2.29,1.03,2.29,2.29v1.53c0,1.26-1.03,2.29-2.29,2.29h-1.53c-1.26,0-2.29-1.03-2.29-2.29v-1.53c0-1.26,1.03-2.29,2.29-2.29h1.53Zm0,1.53h-1.53c-.42,0-.76,.34-.76,.76v1.53c0,.42,.34,.76,.76,.76h1.53c.42,0,.76-.34,.76-.76v-1.53c0-.42-.34-.76-.76-.76Zm-1.53-19.84h-29c-.42,0-.76,.34-.76,.76s.34,.76,.76,.76h29c.42,0,.76-.34,.76-.76s-.34-.76-.76-.76Zm-27.47,6.1h12.21c.42,0,.76-.34,.76-.76s-.34-.76-.76-.76h-12.21c-1.26,0-2.29,1.03-2.29,2.29v6.1c0,1.26,1.03,2.29,2.29,2.29h10.68c1.26,0,2.29-1.03,2.29-2.29v-3.05c0-.42-.34-.76-.76-.76s-.76,.34-.76,.76v3.05c0,.42-.34,.76-.76,.76h-10.68c-.42,0-.76-.34-.76-.76v-6.1c0-.42,.34-.76,.76-.76Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.1b31c7afc45c07cfecf576d5d424db2d.svg";
export { ForwardRef as ReactComponent };